<ng-template #progressDiv let-modal>
    <div class="modal-body" align="center">
        <div class="p-3">
            <div *ngIf="processProgress && processProgress.actualText">{{processProgress.actualText | translate}}</div>
            <div *ngIf="processProgress && processProgress.actualEntityText">{{processProgress.actualEntityText}}</div>
            <div class="progress">
                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" [attr.aria-valuenow]="processProgress.percent" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{ 'width': processProgress.percent + '%' }">{{processProgress.percent}}%</div>
            </div>
        </div>
    </div>
</ng-template>